import { render, staticRenderFns } from "./ZakatPerdagangan.vue?vue&type=template&id=21738c28"
import script from "./ZakatPerdagangan.vue?vue&type=script&lang=js"
export * from "./ZakatPerdagangan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports